// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__20_aX","options":"AnswerScale_options__1QP-y","selected":"AnswerScale_selected__2JxgL"};